import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

const AdditionalDetails = ({ formData, updateFormData, errors, company }) => {
  const intl = useIntl();
  const handleChange = (field) => (e) => {
    updateFormData({ [field]: e.target.value });
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900"><FormattedMessage id="succession_deals.wizard.steps.additional_details.title" /></h2>
        <p className="mt-2 text-lg text-gray-600">
          <FormattedMessage id="succession_deals.wizard.steps.additional_details.description" />
        </p>
      </div>

      <div className="space-y-6">
        <div>
          <label htmlFor="growth_opportunities" className="block text-sm font-medium text-gray-700 mb-2">
            <FormattedMessage id="succession_deals.wizard.steps.additional_details.growth_opportunities_label" />
          </label>
          <textarea
            id="growth_opportunities"
            rows={4}
            value={formData.growth_opportunities || ''}
            onChange={handleChange('growth_opportunities')}
            className="block w-full border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            placeholder={intl.formatMessage({ id: 'succession_deals.wizard.steps.additional_details.growth_opportunities_placeholder' })}
          />
        </div>

        <div>
          <label htmlFor="invitation_deadline" className="block text-sm font-medium text-gray-700 mb-2">
            <FormattedMessage id="succession_deals.wizard.steps.additional_details.invitation_deadline_label" />
          </label>
          <input
            type="date"
            id="invitation_deadline"
            value={formData.invitation_deadline || ''}
            onChange={handleChange('invitation_deadline')}
            className="block w-full border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          />
          <p className="mt-1 text-xs text-gray-500">
            <FormattedMessage id="succession_deals.wizard.steps.additional_details.invitation_deadline_help" />
          </p>
        </div>
      </div>
    </div>
  );
};

AdditionalDetails.propTypes = {
  formData: PropTypes.object.isRequired,
  updateFormData: PropTypes.func.isRequired,
  errors: PropTypes.object,
  company: PropTypes.object
};

export default AdditionalDetails;
